@if (isVisible()) {
  <div class="prompt-overlay" (click)="onDismiss()"></div>
  <div class="prompt-card">
    <!-- Bell Icon -->
    <div class="prompt-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    </div>

    <!-- Title -->
    <h3 class="prompt-title">{{ 'notifications.promptTitle' | translate }}</h3>

    <!-- Message -->
    <p class="prompt-message">{{ 'notifications.promptMessage' | translate }}</p>

    <!-- Buttons -->
    <div class="prompt-actions">
      <button class="prompt-btn-enable" (click)="onEnable()">
        {{ 'notifications.enableButton' | translate }}
      </button>
      <button class="prompt-btn-dismiss" (click)="onDismiss()">
        {{ 'notifications.notNowButton' | translate }}
      </button>
    </div>
  </div>
}
